module.exports = __webpack_public_path__ + "assets/img/fd0cd054608730b0f3b1d9c9170557aa.png";